// export default 'https://app.ourbethel.cn/bethelapp/v2/';
// export const portalUrl = 'http://192.168.10.8:9528/api/';
// export const portalUrl = 'https://portal.ourbethel.cn/api/';

export default 'https://app.ourbethel.cn/bethelapp/v2/';
// export const portalUrl = 'http://127.0.0.1:9528/api/';
export const portalUrl = 'https://portal.ourbethel.cn/api/';

// {
//   "initial": "r",
//   "id": "r008"
// },
// {
//   "initial": "r",
//   "id": "r009"
// },
// {
//   "initial": "r",
//   "id": "r010"
// },
// {
//   "initial": "r",
//   "id": "r011"
// },
// {
//   "initial": "r",
//   "id": "r012"
// },
